import Link from "next/link";
import { useTheme } from "next-themes";
import Head from "next/head";
import Image from "next/image";
import { ReactNode, useEffect } from "react";

export default function AuthLayout({
  children,
  title = "PrepCenter",
  heading = "",
  altOptionText = "",
  altOptionLink = "",
  subHeading = "",
}: {
  children: ReactNode;
  title?: string;
  heading?: string;
  subHeading?: string;
  altOptionText?: string;
  altOptionLink?: string;
}) {
  const { setTheme } = useTheme();

  useEffect(() => {
    setTheme("light");
  }, [setTheme]);

  return (
    <>
      <Head>
        <title>{title}</title>
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <div className="min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <div className="relative mx-auto h-16 w-auto">
            <Image layout="fill" src="/images/icon-dark.svg" alt="PrepCenter" />
          </div>
          <h2 className="mt-4 text-center text-3xl font-extrabold text-gray-900">
            {heading}
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            {subHeading ? subHeading : <>Or </>}
            <Link href={altOptionLink}>
              <a className="font-medium text-vendrive-600 hover:text-vendrive-500">
                {altOptionText}
              </a>
            </Link>
          </p>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            {children}
          </div>
        </div>
      </div>
    </>
  );
}
